import { render, staticRenderFns } from "./getSuperPassword.vue?vue&type=template&id=677d6955&"
import script from "./getSuperPassword.vue?vue&type=script&lang=js&"
export * from "./getSuperPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "getSuperPassword.vue"
export default component.exports